import { DROPDOWN_CLASS_NAME } from '../constants/dropdownClassName'

/* Don't use this for anything critical. Not bulletproof for sure.
Slightly hacky but the least invasive way to determine if any dropdown is currently open.
Dropdown's wrapper is always mounted in the DOM, so its presence alone doesn't indicate an open dropdown. 
This is not entirely perfect, but as dropdown is one of the most used components, it is tricky to change behaviour for all.
So if there's some content inside = dropdown is open.
 */
export const isAnyDropdownOpen = () => {
  const dropdownElements = Array.from(document.getElementsByClassName(DROPDOWN_CLASS_NAME))
  return dropdownElements.some((dropdownElement) => dropdownElement.childElementCount > 0)
}
